import React from 'react';
import { Redirect } from 'react-router-dom';

const AuthenticatedRedirect = () => {
  return <Redirect to="/home" />;
};

export default AuthenticatedRedirect;
